<section>
    <p id="number">404</p>
    <p id="text">Ups... La página no ha sido encontrada</p>
</section>